import React, { createContext, useContext, useMemo, useState } from 'react';

import { SelectedFavouriteStationContext as Context } from './types';

const SelectedFavouriteStationContext = createContext({} as Context);
export const useSelectedFavouriteStationContext = () => useContext(SelectedFavouriteStationContext);

interface Props {
  children: React.ReactNode;
}

export const SelectedFavouriteStationProvider = (props: Props) => {
  const [ selectedFavouriteStation, setSelectedFavouriteStation ] = useState<Context['selectedFavouriteStation']>();

  const value = useMemo(() => ({
    selectedFavouriteStation,
    setSelectedFavouriteStation
  }), [
    selectedFavouriteStation,
    setSelectedFavouriteStation
  ]);

  return (
    <SelectedFavouriteStationContext.Provider value={value}>{props.children}</SelectedFavouriteStationContext.Provider>
  );
};
